import { render, staticRenderFns } from "./ImportXmlCteDetails.vue?vue&type=template&id=651aeaaa&scoped=true"
import script from "./ImportXmlCteDetails.vue?vue&type=script&lang=js"
export * from "./ImportXmlCteDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "651aeaaa",
  null
  
)

export default component.exports